import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import pageStyles from './BusinessEnterpriseNetworkPage.module.css';
import { FlagIcon } from '../../../components/common/FlagIcon/FlagIcon';
import { Accordion } from '../../../components/no-auth/common/accordion/Accordion';
import styles from '../../../components/no-auth/common/accordion/Accordion.module.css';
import { DropdownList } from '../../../components/no-auth/common/dropdown-list/DropdownList';
import { PromoText } from '../../../components/no-auth/common/promo-text/PromoText';
import { HeroSection } from '../../../components/no-auth/common/sections/HeroSection';
import { HighlightedTilesSection } from '../../../components/no-auth/common/sections/HighlightedTilesSection';
import { CommonSection } from '../../../components/no-auth/common/sections/styles';
import { TilesSection } from '../../../components/no-auth/common/sections/TilesSection';
import PaymentOptionContent from '../../../components/no-auth/enterpriseNetwork/PaymentOptionContent';

const BusinessEnterpriseNetworkPage = (props) => {
    const [selectedRegion, setSelectedRegion] = useState(props.allRegionsTitle);

    const regionItems = useMemo(() => {
        const regions = [props.allRegionsTitle];

        props.paymentOptions?.forEach((option) => {
            const region = option.country?.country_region?.region;
            if (region && !regions.includes(region)) {
                regions.push(region);
            }
        });

        return regions.map((region) => ({
            key: region,
            value: region,
        }));
    }, [props.paymentOptions]);

    const filteredPaymentOptions = useMemo(() => {
        if (!props.paymentOptions) return [];
        if (selectedRegion === props.allRegionsTitle) return props.paymentOptions;

        return props.paymentOptions.filter((option) => option.country?.country_region?.region === selectedRegion);
    }, [props.paymentOptions, selectedRegion]);

    const handleRegionChange = (item) => {
        setSelectedRegion(item.value);
    };

    const getItems = () => {
        return filteredPaymentOptions.map((o) => {
            return {
                header: (
                    <div className={styles.accordionHeaderContent}>
                        {o.country.code_a2 && (
                            <div className={styles.accordionFlag}>
                                <FlagIcon name={`${o.country.code_a2.toLowerCase()}`} size={'24px'} />
                            </div>
                        )}
                        {o.country.name && (
                            <PromoText color={'white'} tag={'span'}>
                                {o.country.name}
                            </PromoText>
                        )}
                    </div>
                ),
                content: <PaymentOptionContent paymentGroup={o.payment_group} settlement={o.instant_settlement} />,
            };
        });
    };

    return (
        <PromoPageContainer bgColor="baseColor" noIndent>
            {props.heroTitle && (
                <HeroSection title={props.heroTitle} text={props.heroText} data={props.heroData} btnVariant="primary" isInvertedBtn noIconBtn promoDarkPage />
            )}
            <ColoredSectionContainer>
                {props.headline1Title && <HeadingSection whiteTitle title={props.headline1Title} text={props.headline1Text} />}
                {props.highLightedTiles && <HighlightedTilesSection titleH2 promoDarkPage data={props.highLightedTiles} />}
                {props.headline2Title && <HeadingSection whiteTitle title={props.headline2Title} text={props.headline2Text} />}

                {Array.isArray(props.paymentOptions) && (
                    <CommonSection>
                        <div className={pageStyles.regionDropdown}>
                            <DropdownList listItems={regionItems} onSelectChange={handleRegionChange} selectedValue={selectedRegion} isBordered />
                        </div>
                        <Accordion items={getItems()} contentNoPadding promoDarkPage isCompact />
                    </CommonSection>
                )}

                {props.headline3Title && (
                    <HeadingSection
                        whiteTitle
                        title={props.headline3Title}
                        text={props.headline3Text}
                        btn={props.headline3Btn}
                        variant={'secondary'}
                        isInverted
                    />
                )}
            </ColoredSectionContainer>
            <ColoredSectionContainer bottomPadding>
                {props.tiles1 && <TilesSection data={props.tiles1} lang={props.lang} country={props.country} />}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.page_data?.hero_block?.title,
        heroText: state.extra?.strapiApi?.page_data?.hero_block?.text,
        heroData: state.extra?.strapiApi?.page_data?.hero_block,

        headline1Title: state.extra?.strapiApi?.page_data?.headline_1?.title,
        headline1Text: state.extra?.strapiApi?.page_data?.headline_1?.text,

        highLightedTiles: state.extra?.strapiApi?.page_data?.tiles_highlighted,

        headline2Title: state.extra?.strapiApi?.page_data?.headline_2?.title,
        headline2Text: state.extra?.strapiApi?.page_data?.headline_2?.text,
        headline2Btn: state.extra?.strapiApi?.page_data?.headline_2?.btn,

        paymentOptions: state.extra?.strapiApi?.payment_options,
        allRegionsTitle: state.extra?.strapiApi?.page_data?.all_regions_title,

        headline3Title: state.extra?.strapiApi?.page_data?.headline_3?.title,
        headline3Text: state.extra?.strapiApi?.page_data?.headline_3?.text,
        headline3Btn: state.extra?.strapiApi?.page_data?.headline_3?.btn,

        tiles1: state.extra?.strapiApi?.page_data?.tiles_section_1,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(BusinessEnterpriseNetworkPage));
